const stats = [
  { value: '1,000+', label: 'Parts In Stock' },
  { value: '25+', label: 'Years in Business' },
  { value: '50,000+', label: 'Orders Shipped' },
  { value: '4.9★', label: 'Avg Customer Rating' },
];

const reasons = [
  {
    icon: 'ri-database-2-line',
    title: 'Massive Inventory Depth',
    desc: 'Over 1,000 SKUs covering vertical blinds, mini blinds, drapery hardware, and roller shades. We stock the hard-to-find parts big-box stores don\'t carry.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'In Business Since 1997',
    desc: 'Over 25 years as a trusted blind parts supplier. We\'ve helped hundreds of thousands of homeowners, landlords, and property managers get their blinds working again.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Nationwide Fast Shipping',
    desc: 'We ship to all 50 states from our central warehouse. Most orders ship within 1–2 business days. Free shipping on orders over $49.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Parts Experts On Staff',
    desc: 'Our team knows window hardware inside and out. Call us and a real specialist will help you identify the exact part you need — even for discontinued or rare models.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Universal Compatibility',
    desc: 'Most parts we carry are universal-fit, compatible across major brands including Levolor, Hunter Douglas, Bali, Graber, and Springs Window Fashions.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Easy 30-Day Returns',
    desc: 'Ordered the wrong part? No problem. We accept returns within 30 days on all stocked items, no questions asked. Getting the right part matters to us.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-stone-900 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-400 text-xs font-bold tracking-widest uppercase mb-3">
            Why Shop With Us
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-white">
            The Blind Parts Store Pros Trust
          </h2>
          <p className="text-stone-400 mt-3 text-base max-w-xl mx-auto leading-relaxed">
            Specialists, installers, property managers, and homeowners have relied on us since 1997 for reliable parts at fair prices.
          </p>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-stone-700 rounded-lg overflow-hidden mb-14">
          {stats.map((s) => (
            <div key={s.label} className="bg-stone-800 px-6 py-7 text-center">
              <div className="text-amber-400 font-bold text-4xl leading-none mb-2">{s.value}</div>
              <div className="text-stone-400 text-sm">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Reasons grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((r) => (
            <div key={r.title} className="bg-stone-800 rounded-lg p-6 border border-stone-700 hover:border-amber-700/50 transition-colors">
              <div className="w-11 h-11 flex items-center justify-center bg-amber-600/15 rounded-lg mb-4">
                <i className={`${r.icon} text-amber-500 text-xl`} />
              </div>
              <h3 className="font-bold text-white text-base mb-2">{r.title}</h3>
              <p className="text-stone-400 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
